module.exports = __webpack_public_path__ + "img/13_Mid-body+GC.948dc36b.png";